/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterJobLevel = {
    filterType: CompositeSearchEnhancedFilterJobLevel.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<number>;
};

export namespace CompositeSearchEnhancedFilterJobLevel {

    export enum filterType {
        JOB_LEVEL = 'jobLevel',
    }


}

